<template>
  <section>
    <div class="row justify-content-center mb-3">
      <div class="col col-md-6 col-lg-4">
        <input type="text" class="form-control" placeholder="Nombre" v-model="client.name">
      </div>
    </div>

    <div class="row justify-content-center mb-3">
      <div class="col col-md-6 col-lg-4">
        <input type="text" class="form-control" placeholder="Email" v-model="client.email">
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col col-md-6 col-lg-4 mexican-container-cellphone-input">
        <vue-tel-input
          :defaultCountry="client.cellphoneCountryCodeName"
          :dropdownOptions="dropdownTelephone"
          :inputOptions="inputTelephone"
          styleClasses="form-control d-flex ps-0"
          v-model="client.cellphone"
          @country-changed="countryChanged"
        >
        </vue-tel-input>
      </div>
    </div>
  </section>
</template>

<script>
  import segmentTrack from '../../../../common/mixins/segmentTrack'

  export default {
    mixins: [segmentTrack],

    data() {
      return {
        dropdownTelephone:{
          showDialCodeInSelection: true,
          showFlags: true,
          showDialCodeInList: true,
          showSearchBox: true,
        },
        inputTelephone:{
          placeholder: 'Celular',
          styleClasses: 'text-center',
        }
      }
    },

    mounted() {
      this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Client Information Step')
    },

    computed: {
      client: {
        get() { return this.$store.state.client; },

        set(value) {
          this.$store.commit('setClient', value);
        }
      }
    },

    methods: {
      countryChanged(country) {
        this.client.cellphoneCountryCode = `+${country.dialCode}`;
        this.client.cellphoneCountryCodeName = country.iso2;
      }
    }
  }
</script>
